export default function HudLoader({ text = "Loading" }: { text?: string }) {
  return (
    <div className="hud-loader" role="status" aria-label={text}>
      <div className="hud-loader-text">{text}</div>
      <div className="hud-loader-bar">
        <div className="hud-loader-fill" />
      </div>
    </div>
  )
}
